import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as QQIcon } from '../resources/QQ-Icon.svg';
import LanguageSelector from './LanguageSelector';
import '../styles/welcome.css';

/**
 * Shared shell for public marketing/legal pages: same gradient hero as Welcome,
 * simplified header (brand pill + language), glass content panel.
 * Does not include the POI hero photo layers (gradient only).
 */
function PublicHeroPageLayout({ children }) {
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const toggleLanguageMenu = useCallback(() => {
    setLanguageMenuOpen((open) => !open);
  }, []);

  return (
    <div className="welcome-page relative flex min-h-screen flex-col overflow-x-hidden bg-white font-sans text-slate-800">
      <section
        className="relative flex min-h-[100svh] min-h-[600px] flex-1 flex-col overflow-hidden text-white"
        style={{
          background:
            'linear-gradient(145deg, #041f24 0%, #0c4a5c 38%, #14464F 62%, #1f6d68 100%)',
        }}
      >
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-[#041f24] via-qq-ocean via-qq-teal to-[#1f6d68]" />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/25 via-transparent to-black/40" />

        <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-1 flex-col px-4 py-6 sm:px-6 lg:max-w-7xl lg:px-8 lg:py-10 2xl:max-w-[90rem]">
          <div className="w-full flex-1 rounded-3xl border border-white/20 bg-white/10 shadow-glass backdrop-blur-md">
            <div className="flex min-h-0 w-full flex-col px-3 pb-8 pt-3 sm:px-[1.125rem] sm:pb-10 sm:pt-[1.125rem] lg:px-[1.375rem] lg:pb-12 lg:pt-[1.375rem]">
              <div className="mb-6 flex flex-wrap items-center justify-between gap-4 border-b border-white/15 pb-6">
                <Link
                  to="/welcome"
                  className="welcome-brand-pill flex items-center gap-3 rounded-full border border-white/60 py-2 pl-2 pr-4 shadow-sm transition hover:border-white/75 sm:pl-3 sm:pr-5"
                >
                  <QQIcon className="h-9 w-9 shrink-0 text-qq-teal sm:h-10 sm:w-10" />
                  <span
                    className="text-lg font-bold tracking-wide text-qq-teal sm:text-xl"
                    style={{ fontFamily: "'Josefin Sans', sans-serif" }}
                  >
                    Quisqueya Quest
                  </span>
                </Link>
                <div className="flex items-center bg-transparent p-0">
                  <LanguageSelector
                    onPopupToggle={toggleLanguageMenu}
                    isOpen={languageMenuOpen}
                    highResFlags
                    flushChrome
                  />
                </div>
              </div>
              {children}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PublicHeroPageLayout;
